/* eslint-disable func-names, max-len, no-underscore-dangle */
import 'slick-carousel';

const $bannerTrigger = $('.js-learn-more');
const $bannerContent = $('.js-banner-content');
const $bannerImage = $('.js-banner-image');
const $lowerBannerContainer = $('.js-lower-image-container');
const $carouselTop = $('.js-carousel-top');
const $carouselWork = $('.js-carousel-work');
const $carouselWorkNav = $('.js-carousel-work-nav');

if ($bannerTrigger.length > 0) {
  $bannerTrigger.on('click tap', function () {
    $(this).toggleClass('is-open');
    $bannerContent.fadeToggle();

    $carouselTop.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      dots: false,
      infinite: false,
      prevArrow: '<button type="button" aria-label="Previous" class="slick-prev"><i class="fa fa-arrow-circle-left"></i><span class="visuallyhidden">Previous</span></button>',
      nextArrow: '<button type="button" aria-label="Next" class="slick-next"><i class="fa fa-arrow-circle-right"></i><span class="visuallyhidden">Next</span></button>',
      responsive: [{
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    });

    $carouselWork.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
                // asNavFor: '.js-carousel-work-nav',
      draggable: false,
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      fade: true,
      arrows: false,
      responsive: [{
        breakpoint: 960,
        settings: {
                        // arrows: true,
          prevArrow: '<button type="button" aria-label="Previous" class="slick-prev"><i class="fa fa-arrow-circle-left"></i><span class="visuallyhidden">Previous</span></button>',
          nextArrow: '<button type="button" aria-label="Next" class="slick-next"><i class="fa fa-arrow-circle-right"></i><span class="visuallyhidden">Next</span></button>',
        },
      }, {
        breakpoint: 480,
        settings: {
                        // arrows: true,
          prevArrow: '<button type="button" aria-label="Previous" class="slick-prev"><i class="fa fa-arrow-circle-left"></i><span class="visuallyhidden">Previous</span></button>',
          nextArrow: '<button type="button" aria-label="Next" class="slick-next"><i class="fa fa-arrow-circle-right"></i><span class="visuallyhidden">Next</span></button>',
        },
      }],
    });

    $carouselWorkNav.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      draggable: false,
      focusOnSelect: true,
      arrows: false,
      asNavFor: '.js-carousel-work',
      responsive: [{
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: '<button type="button" aria-label="Previous" class="slick-prev"><i class="fa fa-arrow-circle-left"></i><span class="visuallyhidden">Previous</span></button>',
          nextArrow: '<button type="button" aria-label="Next" class="slick-next"><i class="fa fa-arrow-circle-right"></i><span class="visuallyhidden">Next</span></button>',
        },
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: '<button type="button" aria-label="Previous" class="slick-prev"><i class="fa fa-arrow-circle-left"></i><span class="visuallyhidden">Previous</span></button>',
          nextArrow: '<button type="button" aria-label="Next" class="slick-next"><i class="fa fa-arrow-circle-right"></i><span class="visuallyhidden">Next</span></button>',
        },
      }],
    });
  });
}

const alignLowerImage = function () {
  $lowerBannerContainer.css('max-width', $bannerImage.width());
};

$(window).load(alignLowerImage);

$(window).on('resize', () => {
  alignLowerImage();
});
